import React, { useState } from "react";
import { Link } from "@StarberryUtils";
import { Container, Row, Col, Tabs, Tab, Form, Button } from "react-bootstrap";
import "./Calculator.scss";

import MortgageCalculator from "../../calculators/mortgagecalc"



import ScrollAnimation from 'react-animate-on-scroll';
// Header component

const Calculator = (props) => {

    return (
        <React.Fragment>
            <ScrollAnimation animateIn='fadeInUp'  animateOnce={true}>
                <section className="calculator-section">
                    <Container>
                        <Row>
                            <Col lg={3}>
                                <div className="heading">
                                    <h2><i>Mortgage</i> Calculator</h2>
                                </div>
                            </Col>
                            <Col lg={9}>
                                <div className="calculator">
                                    <MortgageCalculator propertyPrice={props.price}/>
                                    {/* <Form className="form-wrapper">
                                        <Form.Group controlId="formBasicEmail " className="xl-order-1">
                                            <Form.Label>Purchase Price (£)</Form.Label>
                                            <Form.Control type="text" placeholder="615,000" />
                                        </Form.Group>

                                        <Form.Group controlId="formBasicEmail " className="order-xl-2">
                                            <Form.Label>Deposit Amount (£)</Form.Label>
                                            <Form.Control type="text" placeholder="61,500" />
                                        </Form.Group>

                                        <Form.Group controlId="formBasicEmail " className="order-xl-4">
                                            <Form.Label>Interest Rate (%)</Form.Label>
                                            <Form.Control type="text" placeholder="2" />
                                        </Form.Group>

                                        <Form.Group controlId="formBasicEmail " className="order-xl-5">
                                            <Form.Label>Repayment Period (years)</Form.Label>
                                            <Form.Control type="text" placeholder="30" />
                                        </Form.Group>

                                        <Form.Group controlId="formBasicEmail " className="order-xl-3">
                                            <Form.Label>Monthly Repayment</Form.Label>
                                            <Form.Control type="text" placeholder="£ 2,045.84" />
                                        </Form.Group>

                                        <div className="btn-form order-xl-6">
                                            <Button variant="primary" type="submit">
                                                Speak with our Broker
                                            </Button>
                                        </div>

                                    </Form> */}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </ScrollAnimation>
        </React.Fragment>
    );
};

export default Calculator;
